import React from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import cn from 'classnames';
import './SnapshopExplainerPanel.scss';
import { isSafari } from 'react-device-detect';
import { Link } from 'react-router-dom';

import snapshopExplainerElement from '../../static/images/add_pin_modal/snapshop_screenshot.png';
import { isLoggedIn, getUserHash, isManager } from '../../Helpers/user_helpers';

import { getSnapshopBookmarkContent } from '../../Helpers/snapshop_helpers';

const SnapshopExplainerPanel = props => {
  const { fullPanel, user, openAuthModal, widePanel } = props;
  const userHash = getUserHash(user);

  const clickBookmark = () => {
    cogoToast.warn(isMobile ? `Snapshop only works on desktop.` : `Please drag this to your bookmarks bar!`);
  };

  return (
    <div className={cn('snapshop-explainer-panel-outer-container', { 'full-panel': fullPanel, 'wide-panel': widePanel })}>
      <img className='preview' src={snapshopExplainerElement} alt='Snapshop Preview' />
      <div className={cn('description-container', { 'wide-panel': widePanel })}>
        <div className='header-wrapper'>
          <div className='header'>Download linking with Snapshop</div>
        </div>
        <div className='subheader'>Add links directly from any website in seconds:</div>
        <div className='bullets'>
          <div className='bullet'>
            <div className='number'>1</div>
            <div className='task'>Drag the Snapshop button below to your bookmarks bar.</div>
          </div>

          {isSafari && (
            <>
              <div className='bullet'>
                <div className='number'>2</div>
                <div className='task'>Click "Safari" in Safari menu &#8594; Preferences &#8594; Advanced &#8594; Show Development Bar</div>
              </div>
              <div className='bullet'>
                <div className='number'>3</div>
                <div className='task'>Click "Develop" in Safari menu &#8594; Disable Cross-Origin Restrictions</div>
              </div>
              <div className='bullet'>
                <div className='number'>4</div>
                <div className='task'>Go a product page on any retailer website.</div>
              </div>
              <div className='bullet'>
                <div className='number'>5</div>
                <div className='task'>Click on Snapshop from your bookmarks to create a link.</div>
              </div>
            </>
          )}

          {!isSafari && (
            <>
              <div className='bullet'>
                <div className='number'>2</div>
                <div className='task'>Go a product page on any retailer website.</div>
              </div>
              <div className='bullet'>
                <div className='number'>3</div>
                <div className='task'>Click on Snapshop from your bookmarks to create a link.</div>
              </div>
            </>
          )}
        </div>
        {!widePanel &&
          (!isLoggedIn(user) ? (
            <div className='login-btn' onClick={() => openAuthModal('login')}>
              Login To Your Account First
            </div>
          ) : isManager(user) ? (
            <Link className='login-btn' to='settings?tab=My+Talent'>
              Go To My Talent
            </Link>
          ) : (
            <a onClick={clickBookmark} className='drag-container' href={getSnapshopBookmarkContent(userHash)}>
              <div className='drag-label'>Snapshop</div>
            </a>
          ))}
        <div className='need-help'>
          {isManager(user) ? (
            <>Snapshop is only available for talent accounts.</>
          ) : (
            <>
              Need help? Click{' '}
              <a target='_blank' rel='noopener noreferrer' href='https://guide.shopmy.us/snapshop'>
                here
              </a>{' '}
              to learn more.
            </>
          )}
        </div>
      </div>
      {widePanel && <div className='snapshop-explainer-wide'>
        {(!isLoggedIn(user) ? (
          <div className='login-btn' onClick={() => openAuthModal('login')}>
            Login To Your Account First
          </div>
        ) : isManager(user) ? (
          <Link className='login-btn' to='settings?tab=My+Talent'>
            Go To My Talent
          </Link>
        ) : (
          <a onClick={clickBookmark} className='drag-container' href={getSnapshopBookmarkContent(userHash)}>
            <div className='drag-label'>Snapshop</div>
          </a>
        ))}
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="21" viewBox="0 0 8 21" fill="none">
          <path d="M4.35355 0.646446C4.15829 0.451185 3.84171 0.451185 3.64645 0.646446L0.464467 3.82843C0.269205 4.02369 0.269205 4.34027 0.464467 4.53553C0.659729 4.7308 0.976311 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 21L4.5 1L3.5 1L3.5 21L4.5 21Z" fill="black"/>
        </svg>
        <span>
          <b>Drag</b>
          <span> to bookmarks bar</span>
        </span>
      </div>}
    </div>
  );
};

SnapshopExplainerPanel.propTypes = {
  user: PropTypes.object.isRequired,
  openAuthModal: PropTypes.func.isRequired,
  fullPanel: PropTypes.bool,
  widePanel: PropTypes.bool
};

export default SnapshopExplainerPanel;
